import { useTranslation } from "react-i18next";

export default function FSTPSelect({ options, value, onChange }) {
  const { t } = useTranslation();
  return (
    <div className="bg-[#1F3A60] text-white rounded-xl shadow-md p-5 flex flex-col md:flex-row md:items-center md:justify-between gap-2">
      <div className="flex items-center gap-2">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-6 w-6 text-blue-200"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.8}
            d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2H3V4zm0 4h18v12a1 1 0 01-1 1H4a1 1 0 01-1-1V8zm5 4h2v4H8v-4zm6 0h2v4h-2v-4z"
          />
        </svg>
        <h2 className="text-lg md:text-xl font-semibold tracking-wide">
          {t("fstp_page.basicInfo.dropdownLabel")}
        </h2>
      </div>

      <div className="relative w-full md:w-96">
        <select
          value={value}
          onChange={(e) => onChange(Number(e.target.value))}
          className="w-full appearance-none bg-white text-gray-800 font-medium border border-gray-300 rounded-lg pl-4 pr-10 py-2.5 shadow-sm focus:ring-2 focus:ring-blue-400 focus:border-blue-400 transition-all duration-200 hover:border-blue-300"
        >
          {options.map((fstp) => (
            <option key={fstp.id} value={fstp.id}>
              {fstp.basicInfo.title}
            </option>
          ))}
        </select>

        {/* Dropdown icon */}
        <svg
          className="w-4 h-4 text-gray-500 absolute right-3 top-1/2 transform -translate-y-1/2 pointer-events-none"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 20 20"
          stroke="currentColor"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7 7l3 3 3-3" />
        </svg>
      </div>
    </div>
  )
}
